import { render, staticRenderFns } from "./ContentViewSettingsMenu.vue?vue&type=template&id=28979c78&scoped=true&"
import script from "./ContentViewSettingsMenu.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsMenu.vue?vue&type=style&index=0&id=28979c78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28979c78",
  null
  
)

export default component.exports